import { useSetState, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import dayjs from 'dayjs'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'
import { certificateFromData } from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import { StatusCode } from '@/constants'
import { DATEPICKER_MIN_DEFAULT_TIMESTAMP } from '@/constants'
import { useCommonForm } from '@/hooks'

import HPopup from '../../HYBVant/HPopup'
import './index.less'

const HealthCertificate: React.FC<any> = ({ visible, onCancel, modalData }) => {
  const {
    staff_id,
    runSaveEducation,
    runDeleteHrmEducation,
    deleteHrmEducationLoading,
    saveEducationLoading,
    status,
    editItem
  } = modalData
  const [formIt] = Form.useForm()
  const [{ randomForm }, setState] = useSetState<any>({
    randomForm: null
  })
  const onFinish = (fieldValues: any) => {
    if (deleteHrmEducationLoading || saveEducationLoading) return
    const attachments = certificateFromData(fieldValues?.attachments || [])
    const start_date_old = fieldValues?.education_date?.[0] || fieldValues?.start_date
    const start_date = start_date_old ? dayjs(start_date_old).format('YYYY-MM-DD') : ''
    const end_date_old = fieldValues?.education_date?.[1] || fieldValues?.end_date
    const end_date = end_date_old ? dayjs(end_date_old).format('YYYY-MM-DD') : ''
    const values_info = {
      ...fieldValues,
      attachments,
      id: editItem?.id || null,
      employee_id: staff_id || null,
      start_date,
      end_date
    }
    runSaveEducation(values_info)
  }

  useDeepCompareEffect(() => {
    const setFieldValues = (bool: boolean) => {
      const start_date_old = editItem?.education_date?.[0] || editItem?.start_date
      const end_date_old = editItem?.education_date?.[1] || editItem?.end_date
      editItem.education_date = start_date_old && end_date_old ? [start_date_old, end_date_old] : []
      formIt.setFieldsValue(editItem)
      setState({ randomForm: Math.random() })
    }
    setFieldValues(status === 'Edit')
  }, [status, editItem])
  const deleteInfo = () => {
    if (status === 'Edit') {
      const fields = editItem
      const id = fields?.id
      const ids = id ? [id] : null
      runDeleteHrmEducation(ids)
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }
  const vars = {
    minDate: DATEPICKER_MIN_DEFAULT_TIMESTAMP
  }
  const { option, optionStatus } = useCommonForm({
    code: 'educational_experience_from',
    vars,
    immediate: true
  })
  return (
    <HPopup
      title='教育经历'
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      {optionStatus === StatusCode.done && (
        <div className='income-tax-declaration-popup'>
          <NewEditForm
            formInst={formIt}
            formInfo={option?.formInfo ?? []}
            onFinish={onFinish}
            randomForm={randomForm}
            formButtons={getFormButtons(modalData?.status === 'Edit')}
          />
        </div>
      )}
    </HPopup>
  )
}

export default HealthCertificate
